export const constraintsPromocao = {
  name: {
    presence: {
      message: "é obrigatório."
    },
    length: {
      maximum: 60,
      message: "é muito grande (máx. 60 caracteres)"
    }
  },
  cpf: {
    presence: {
      message: "é obrigatório."
    },
    isCpf: {
      message: "é inválido."
    },
    length: {
      minimum: 11,
      message: "é muito curto"
    }
  },
  email: {
    presence: {
      message: "é obrigatório."
    },
    email: {
      message: "não é válido."
    },
    length: {
      maximum: 60,
      message: "é muito grande (máx. 60 caracteres)"
    }
  },
  telefone: {
    presence: {
      message: "é obrigatório."
    },
    length: {
      minimum: 11,
      message: "deve conter pelo menos 11 caracteres."
    }    
  }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/newsletter-promocao/constraintsPromocao.js